import { PermissionAction, PermissionScope, PermissionSubject, Role, RolePermissionConstraints } from '@/types';

import { createResourceService } from './resources';

export interface RolePermissionInput {
    scope: PermissionScope;
    subject: PermissionSubject;
    action: PermissionAction;
    constraints?: RolePermissionConstraints;
}

export interface CreateRoleInput {
    name: string;
    memberId?: string;
    permissions: RolePermissionInput[];
}

export type UpdateRoleInput = Partial<CreateRoleInput>;

export const roleService = createResourceService<Role, CreateRoleInput, UpdateRoleInput>('/api/roles');
